<template>
  <div class="login-wrapper">
    <div class="login-box">
      <div class="header">
        <img src="../../assets/logo.png" alt="logo" class="logo" />
        <h1 class="title">代理人端</h1>
        <p class="subtitle">欢迎回来，请登录您的代理人账号</p>
      </div>

      <el-form :model="loginForm" :rules="rules" ref="loginFromRef" class="login-form">
        <el-form-item prop="email">
          <el-input 
            prefix-icon="el-icon-message" 
            v-model="loginForm.email" 
            placeholder="请输入邮箱/用户名"
            >
          </el-input>
        </el-form-item>

        <el-form-item prop="password">
          <el-input
            prefix-icon="el-icon-lock"
            v-model="loginForm.password"
            type="password"
            placeholder="请输入密码"
            show-password
            >
          </el-input>
        </el-form-item>

        <el-form-item prop="code">
          <div class="captcha-container">
            <el-input 
              prefix-icon="el-icon-key" 
              v-model="loginForm.code" 
              placeholder="验证码"
              class="captcha-input"
              >
            </el-input>
            <div class="captcha-img" v-html="code" @click="getCode" title="点击切换验证码"></div>
          </div>
        </el-form-item>

        <div class="action-links">
          <router-link to="/forget">忘记密码？</router-link>
          <router-link to="/register" class="reg-link">注册新账号</router-link>
        </div>

        <el-form-item>
          <el-button type="primary" class="login-btn" @click="login" :loading="loading">
            立即登录
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import CryptoJS from 'crypto-js'

export default {
  data() {
    return {
      loginForm: {
        email: "",
        password: "",
        code: "",
        sign: ""
      },
      code: "",
      loading: false, // 新增 loading 状态
      cachedPwd: "",
      l: null,
      rules: {
        email: [
          { required: true, message: "请输入用户名", trigger: ["blur", "change"] },
          { min: 5, max: 40, message: "长度在 5 到 40 个字符", trigger: ["blur", "change"] },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: ["blur", "change"] },
          { min: 5, max: 16, message: "长度在 5 到 16 个字符", trigger: ["blur", "change"] },
        ],
        code: [{ required: true, message: "请输入验证码", trigger: ["blur", "change"] }],
      },
    };
  },
  created() {
    this.loadLoginInfo()
    this.getCode()
  },
  methods: {
    // 加载本地保存的信息
    loadLoginInfo() {
      const savedUsername = localStorage.getItem('agentemail')
      this.cachedPwd = localStorage.getItem('agentpwd')
      this.l = localStorage.getItem('l')
      if (savedUsername) {
        this.loginForm.email = savedUsername
      }
      if (this.cachedPwd && this.l) {
        this.loginForm.password = '*'.repeat(Number(this.l))
      }
    },
    // 登录逻辑
    login() {
      this.$refs.loginFromRef.validate(async (valid) => {
        if (!valid) {
          return this.$message.error("请完善登录信息");
        }
        
        this.loading = true;
        this.l = this.loginForm.password.length;
        let submitPwd = this.loginForm.password;

        // 回填密码逻辑判断
        if (this.isPureAsterisk(submitPwd) && this.cachedPwd) {
          submitPwd = this.cachedPwd;
        } else {
          submitPwd = CryptoJS.MD5(submitPwd).toString(CryptoJS.enc.Hex);
        }

        try {
          const res = await this.$http.post("agentLogin", {
            email: this.loginForm.email,
            password: submitPwd,
            code: this.loginForm.code,
            sign: this.loginForm.sign
          });

          if (res.data.meta.status !== 200) {
            this.getCode();
            this.loading = false;
            return this.$message.error(res.data.meta.msg);
          }

          // 存储登录信息
          window.localStorage.setItem('agentemail', this.loginForm.email);
          window.localStorage.setItem('agentpwd', submitPwd);
          window.localStorage.setItem('l', this.l);
          
          window.sessionStorage.setItem("token", res.data.data.token);
          window.sessionStorage.setItem('email', res.data.data.result.email);
          window.sessionStorage.setItem('shareId', res.data.data.result.shareId);
          window.sessionStorage.setItem('role', 'agent');

          // Vuex 状态更新
          this.$store.commit('getShareMsg', res.data.data.result.shareId);
          this.$store.commit('getAccount', res.data.data.result.email);

          this.$message.success("登录成功");
          this.$router.push("/welcome");
        } catch (error) {
          this.$message.error("服务器响应失败");
        } finally {
          this.loading = false;
        }
      });
    },
    // 获取验证码
    async getCode() {
      let result = await this.$http.get('getcode?' + Date.parse(new Date()));
      this.code = result.data.img;
      this.loginForm.sign = result.data.sign;
    },
    isPureAsterisk(str) {
      if (!str) return false;
      const reg = /^[*]+$/;
      return reg.test(str);
    },
    changeInput() {
      this.$forceUpdate();
    }
  },
};
</script>

<style lang="less" scoped>
.login-wrapper {
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 20px;
  box-sizing: border-box;
}

.login-box {
  width: 380px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  padding: 40px 30px;
  box-sizing: border-box;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.12);
  }
}

.header {
  text-align: center;
  margin-bottom: 30px;
  .logo {
    width: 60px;
    height: 60px;
    margin-bottom: 15px;
  }
  .title {
    font-size: 24px;
    color: #303133;
    margin: 0 0 10px 0;
    font-weight: 600;
  }
  .subtitle {
    font-size: 14px;
    color: #909399;
    line-height: 1.5;
  }
}

.captcha-container {
  display: flex;
  gap: 12px;
  .captcha-input {
    flex: 1;
  }
  .captcha-img {
    flex: 0 0 110px;
    height: 40px;
    background: #f5f7fa;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    cursor: pointer;
    overflow: hidden;
    /deep/ div, /deep/ svg {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}

.action-links {
  display: flex;
  justify-content: space-between;
  margin: -10px 0 25px 0;
  
  a {
    font-size: 13px;
    color: #606266;
    text-decoration: none;
    transition: color 0.2s;

    &:hover {
      color: #409eff;
      text-decoration: underline;
    }
  }

  .reg-link {
    color: #409eff;
    font-weight: 500;
  }
}

.login-btn {
  width: 100%;
  height: 42px;
  font-size: 16px;
  letter-spacing: 2px;
  border-radius: 8px;
  background-color: #409eff;
  border: none;
  
  &:hover {
    opacity: 0.9;
  }
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  /deep/ .el-input__inner {
    font-size: 16px !important;
  }
  
  .login-wrapper {
    background: #ffffff;
    align-items: flex-start;
    padding-top: 15%;
  }
  .login-box {
    width: 100%;
    max-width: 100%;
    box-shadow: none;
    padding: 20px;
  }
}
</style>